import camelCase from 'lodash/camelCase';

/**
 *
 * @param {String} dotString
 * @returns {String}
 */
export default function (dotString) {
  if (!dotString) {
    return dotString;
  }

  return dotString
    .split('.')
    .map((part) => {
      const breacketIndex = part.indexOf('[');
      if (breacketIndex === -1) {
        return camelCase(part);
      }

      return `${camelCase(part.substr(0, breacketIndex))}${part.substr(breacketIndex)}`;
    })
    .join('.');
}
